import { render } from "./EndorserModal.vue?vue&type=template&id=1c6cd32c"
import script from "./EndorserModal.vue?vue&type=script&lang=js"
export * from "./EndorserModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__